import { ICustomIconProps } from './types';

const IconPresentionChart: React.FC<ICustomIconProps> = ({ size = 20, color = '#9F9F9F', className }) => (
  <svg width={size} height={size} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path
      d='M4.91666 14.1667H15.075C16.6583 14.1667 17.4917 13.3333 17.4917 11.75V1.66666H2.49166V11.75C2.49999 13.3333 3.33333 14.1667 4.91666 14.1667Z'
      stroke={color}
      strokeWidth='1.5'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M1.66666 1.66666H18.3333' stroke={color} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M6.66666 18.3333L10 16.6667V14.1667' stroke={color} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M13.3333 18.3333L10 16.6667' stroke={color} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M6.25 9.16666L8.87499 6.97499C9.08333 6.79999 9.35833 6.84999 9.49999 7.08332L10.5 8.74999C10.6417 8.98332 10.9167 9.02499 11.125 8.85833L13.75 6.66666'
      stroke={color}
      strokeWidth='1.5'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default IconPresentionChart;
